"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var LoggedInUserQuery = /** @class */ (function (_super) {
    __extends(LoggedInUserQuery, _super);
    function LoggedInUserQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoggedInUserQuery.prototype.initialize = function (executionOptions) {
    };
    LoggedInUserQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, key = _a.key, code = _a.code, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ key: key,
            code: code }, (options.loggedInUser || {}));
    };
    LoggedInUserQuery.prototype.getRawValue = function (executionOptions) {
        var _a = this.options, key = _a.key, code = _a.code;
        var loggedInUser = this.getLoggedInUser(executionOptions);
        if (loggedInUser) {
            if (code) {
                var result = loggedInUser[code];
                if (key && Array.isArray(result)) {
                    result = result.map(function (element) { return element[key]; });
                }
                return result;
            }
            return loggedInUser;
        }
        return;
    };
    return LoggedInUserQuery;
}(BaseQuery_1.BaseQuery));
exports.LoggedInUserQuery = LoggedInUserQuery;
//# sourceMappingURL=LoggedInUserQuery.js.map